import React from 'react'

const FOOTER_LINK_TYPES = {
  URL: 'URL',
  ACTION: 'ACTION',
  JAVASCRIPT_CODE: 'JAVASCRIPT_CODE',
}

const FOOTER_LINK_ACTIONS = {
  COOKIE_BANNER: 'COOKIE_BANNER',
}

const footerLinkActionHandlers = {
  [FOOTER_LINK_ACTIONS.COOKIE_BANNER]: () => {
    if (typeof window !== 'undefined') {
      window?.Cookiebot?.show()
    }
  },
}

const FooterLink = ({ item }) => {
  const handleClick = e => {
    const linkType = item.type || FOOTER_LINK_TYPES.URL

    switch (linkType) {
      case FOOTER_LINK_TYPES.URL:
        return

      case FOOTER_LINK_TYPES.ACTION:
        e.preventDefault()
        const handler = footerLinkActionHandlers[item.action]
        if (handler) {
          handler()
        } else {
          console.warn(`Unknown footer link action: ${item.action}`)
        }
        break

      case FOOTER_LINK_TYPES.JAVASCRIPT_CODE:
        e.preventDefault()
        try {
          const executeCode = new Function(item.action)
          executeCode()
        } catch (error) {
          console.error('Error executing footer link JavaScript:', error)
        }
        break

      default:
        console.warn(`Unknown footer link type: ${linkType}`)
    }
  }

  const linkType = item.type || FOOTER_LINK_TYPES.URL
  const href = linkType === FOOTER_LINK_TYPES.URL ? item.url : '#'
  const shouldOpenInNewTab = linkType === FOOTER_LINK_TYPES.URL

  return (
    <a
      className="embed-footer-links"
      href={href}
      onClick={handleClick}
      {...(shouldOpenInNewTab && {
        target: '_blank',
        rel: 'noopener noreferrer',
      })}
    >
      {item.label}
    </a>
  )
}

export default FooterLink
